import React, { useState } from 'react';
import './SavedFiltersSidebar.css';

const SavedFiltersSidebar = ({ 
  isOpen, 
  onClose, 
  savedFilters, 
  filterName,
  onFilterNameChange,
  onSaveFilter,
  onLoadFilter,
  onDeleteFilter,
  currentSport
}) => {
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);

  const handleDeleteClick = (filterId) => {
    if (deleteConfirmId === filterId) {
      onDeleteFilter(filterId);
      setDeleteConfirmId(null);
    } else {
      setDeleteConfirmId(filterId);
    }
  };

  const handleSaveClick = () => {
    if (filterName.trim()) {
      onSaveFilter();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSaveClick();
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="saved-filters-overlay" onClick={onClose}></div>
      <div className="saved-filters-sidebar">
        <div className="saved-filters-header">
          <h3>Saved Filters</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="saved-filters-content">
          <div className="save-filter-section">
            <h4>Save Current Filter</h4>
            <div className="save-filter-input-group">
              <input
                type="text"
                placeholder="Filter name..."
                value={filterName}
                onChange={(e) => onFilterNameChange(e.target.value)}
                onKeyPress={handleKeyPress}
                className="filter-name-input"
              />
              <button 
                onClick={handleSaveClick}
                disabled={!filterName.trim()}
                className="save-filter-button"
              >
                Save
              </button>
            </div>
          </div>

          <div className="saved-filters-list">
            <h4>Your Filters</h4>
            {savedFilters.length === 0 ? (
              <p className="no-filters-message">No saved filters yet</p>
            ) : (
              <div className="filter-items">
                {savedFilters.map((filter) => (
                  <div key={filter.id} className="filter-item">
                    <div className="filter-item-header">
                      <span className="filter-item-name">{filter.name}</span>
                      <small>{filter.criteria?.version === 2
                        ? `${filter.criteria.category} · ${filter.criteria.gradingFeeMode}`
                        : 'Current view · legacy filter'}</small>
                      <span className="filter-item-date">
                        {new Date(filter.created_at).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="filter-item-actions">
                      <button
                        onClick={() => onLoadFilter(filter)}
                        className="load-filter-button"
                      >
                        Apply
                      </button>
                      <button
                        onClick={() => handleDeleteClick(filter.id)}
                        className={`delete-filter-button ${deleteConfirmId === filter.id ? 'confirm' : ''}`}
                      >
                        {deleteConfirmId === filter.id ? 'Confirm?' : 'Delete'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SavedFiltersSidebar;

